import { Spinner } from 'react-bootstrap'

function Loading() {
  return (
    <div className="loading-wrapper">
      <Spinner animation="border" role="status" aria-label="Carregando" />
      <p>CARREGANDO</p>
    </div>
  )
}

export default Loading